import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import tras from 'translate';
import { createNotificationAction } from '../../../../redux/actions/uiActions';
import './TileFooter.scss';

const TileFooter = ({ text, func, color, tileInfo, statusObject, createNotificationAction }) => {
  const hasError = statusObject?.disableConditions?.(tileInfo).find((err) => err.condition);

  const handleClick = () => {
    if (hasError) {
      createNotificationAction('error', hasError?.msg, 5000);
      return;
    }
    func({ ...tileInfo, hasError });
  };

  return (
    <div
      className={clsx('pool-tile-footer', { disabled: hasError })}
      style={{ background: color }}
      onClick={handleClick}
    >
      {tras(text)}
    </div>
  );
};

TileFooter.propTypes = {
  text: PropTypes.string.isRequired,
  func: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  tileInfo: PropTypes.object.isRequired,
  createNotificationAction: PropTypes.func.isRequired,
  statusObject: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  createNotificationAction,
};

export default connect(undefined, mapDispatchToProps)(TileFooter);
